/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OverwatchMapTripAnnotationsQueryVariables = Types.Exact<{
  tripId?: Types.InputMaybe<Types.Scalars['String']['input']>
  vtrId?: Types.InputMaybe<Types.Scalars['String']['input']>
  metropolisId?: Types.InputMaybe<Types.Scalars['Int']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
  withClassification: Types.Scalars['Boolean']['input']
  withTranscriptEditing: Types.Scalars['Boolean']['input']
}>

export type OverwatchMapTripAnnotationsQuery = {
  __typename?: 'Query'
  tripAnnotations: Array<{
    __typename?: 'TripAnnotation'
    annotationId: string
    recordedAtMs: number
    vehicleId: string
    driverId: string
    severity: Types.TripAnnotationSeverity
    tripId: string | null
    vtrId: string | null
    transcriptionStatus: Types.TripAnnotationTranscriptionStatus
    transcript: string | null
    audioS3Uri: string | null
    answeredAtMs: number | null
    answeredBy: string | null
    jiraIssueKey: string | null
    location: {
      __typename?: 'TripGeolocation'
      latitude: number
      longitude: number
    }
    resolution: {
      __typename?: 'AnnotationResolution'
      resolvedAtMs: number
      resolvedBy: string
      evidenceType: string
      evidenceRef: string
      note: string | null
    } | null
    transcriptTurns?: Array<{
      __typename?: 'TranscriptTurn'
      speaker: Types.TranscriptTurnSpeaker
      text: string
    }>
    transcriptCorrection?: {
      __typename?: 'AnnotationTranscriptCorrection'
      correctedAtMs: number
      correctedBy: string
    } | null
    classification?: {
      __typename?: 'AnnotationClassification'
      category: Types.AnnotationCategory
      reasonCode: Types.AnnotationReasonCode | null
      reasonPath: Array<string>
      taxonomyVendor: string | null
      taxonomyVersion: string | null
      source: Types.AnnotationClassificationSource
      confidence: number | null
      trafficLawViolation: boolean | null
      mapContribution: boolean | null
      createdAtMs: number
      createdBy: string | null
    } | null
  }>
}

export const OverwatchMapTripAnnotationsDocument = gql`
    query OverwatchMapTripAnnotations($tripId: String, $vtrId: String, $metropolisId: Int, $limit: Int, $offset: Int, $withClassification: Boolean!, $withTranscriptEditing: Boolean!) {
  tripAnnotations(
    tripId: $tripId
    vtrId: $vtrId
    metropolisId: $metropolisId
    limit: $limit
    offset: $offset
  ) {
    annotationId
    recordedAtMs
    vehicleId
    driverId
    severity
    location {
      latitude
      longitude
    }
    tripId
    vtrId
    transcriptionStatus
    transcript
    audioS3Uri
    answeredAtMs
    answeredBy
    resolution {
      resolvedAtMs
      resolvedBy
      evidenceType
      evidenceRef
      note
    }
    jiraIssueKey
    transcriptTurns @include(if: $withTranscriptEditing) {
      speaker
      text
    }
    transcriptCorrection @include(if: $withTranscriptEditing) {
      correctedAtMs
      correctedBy
    }
    classification @include(if: $withClassification) {
      category
      reasonCode
      reasonPath
      taxonomyVendor
      taxonomyVersion
      source
      confidence
      trafficLawViolation
      mapContribution
      createdAtMs
      createdBy
    }
  }
}
    `

/**
 * __useOverwatchMapTripAnnotationsQuery__
 *
 * To run a query within a React component, call `useOverwatchMapTripAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapTripAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapTripAnnotationsQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      vtrId: // value for 'vtrId'
 *      metropolisId: // value for 'metropolisId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      withClassification: // value for 'withClassification'
 *      withTranscriptEditing: // value for 'withTranscriptEditing'
 *   },
 * });
 */
export function useOverwatchMapTripAnnotationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  > &
    (
      | { variables: OverwatchMapTripAnnotationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >(OverwatchMapTripAnnotationsDocument, options)
}
export function useOverwatchMapTripAnnotationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >(OverwatchMapTripAnnotationsDocument, options)
}
// @ts-ignore
export function useOverwatchMapTripAnnotationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapTripAnnotationsQuery,
  OverwatchMapTripAnnotationsQueryVariables
>
export function useOverwatchMapTripAnnotationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapTripAnnotationsQuery,
        OverwatchMapTripAnnotationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapTripAnnotationsQuery | undefined,
  OverwatchMapTripAnnotationsQueryVariables
>
export function useOverwatchMapTripAnnotationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapTripAnnotationsQuery,
        OverwatchMapTripAnnotationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >(OverwatchMapTripAnnotationsDocument, options)
}
export type OverwatchMapTripAnnotationsQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationsQuery
>
export type OverwatchMapTripAnnotationsLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationsLazyQuery
>
export type OverwatchMapTripAnnotationsSuspenseQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationsSuspenseQuery
>
export type OverwatchMapTripAnnotationsQueryResult = Apollo.QueryResult<
  OverwatchMapTripAnnotationsQuery,
  OverwatchMapTripAnnotationsQueryVariables
>
